// Shared API client configuration
import axios, { AxiosInstance } from 'axios'
import {
  setupRequestInterceptor,
  handleRequestError,
  handleResponseSuccess,
  handleResponseError
} from '../interceptors'

// Create axios instance
export const apiClient: AxiosInstance = axios.create({
  baseURL: (import.meta as any).env?.VITE_API_URL || '/api/v1',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Setup interceptors
apiClient.interceptors.request.use(setupRequestInterceptor, handleRequestError)
apiClient.interceptors.response.use(handleResponseSuccess, handleResponseError)

// API response types
export interface ApiResponse<T = any> {
  success: boolean
  message?: string // Success message from backend (in user's language)
  data?: T
  error?: {
    type: string
    message: string
    details?: any
    field?: string // For validation errors
    timestamp: string
    requestId?: string
  }
}

